import $ from 'jquery';

export default class Select {
  constructor({ el }) {
    this.$el = $(el);
    if (!this.$el.parent('.select-wrapper').length && !this.$el.hasClass('product-variants')) {
      this.$el
        .wrap("<div class='select-wrapper' />")
        .parent()
        .prepend('<svg role="img" class="select-dropdown"><use xlink:href="#icon-dropdown"></use></svg>')
        .prepend("<span class='selected-text'></span>");
    }

    this.updateSelectText();

    if (!this.$el.hasClass('product-variants')) {
      this.$el.show();
    }

    this.$el.on('change.select', () => this.updateSelectText());
    $('#address-country').on('change.select', () => {
      this.updateSelectText('province');
    });
  }

  updateSelectText(select) {
    let target;
    if (select === 'province') {
      target = $('#address-province');
    } else {
      target = this.$el;
    }

    const newOption = target.find('option:selected').text() || target.find('option').eq(0).val();
    target.siblings('.selected-text').text(newOption);
  }

  unload() {
    this.$el.off('.select');
  }
}
